<template>
  <banner-carousel :items="items" />
</template>

<script>
import BannerCarousel from "@/components/BannerCarousel.vue";

export default {
  name: "HomeBannerRail",
  components: { BannerCarousel },
  props: {
    items: { type: Array, default: () => [] },
  },
};
</script>
